module.exports = __webpack_public_path__ + "static/dcmhomes-logo-large-83854193103a14c8c5f8143551051855.jpg";